module.exports = __webpack_public_path__ + "static/prosper-logo-d5e6a7132fbe797c16865e1e2b7d6c26.png";